<template>
    <div class="gray-back" >
      <van-tabs v-model="active" class="tab-nav" sticky @click="onStatusChange">
        <van-tab title="正常"></van-tab>
        <van-tab title="隐藏"></van-tab>
      </van-tabs>
        <div class="box">
            <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                <van-list
                        v-model="loading"
                        :finished="finished"
                        finished-text="没有更多了"
                        @load="onLoad"
                >
                    <div class="kaojicenter-list-box">
                        <div class="kaojicenter-lists flex-between" v-for="(item, index) in list"
                             @click="action(item, index)">
                            <div class="kaojicenter-rights">
                                <div class="title">{{item.name}}</div>
                                <div class="desc flex-start">
                                    <van-tag round v-if="item.cert_status==1"   type="success">已认证</van-tag>
                                    <van-tag round v-else-if="item.cert_status==3"   >认证失败</van-tag>
                                    <van-tag round v-else-if="item.cardtype==1 && item.cert_status==2"   type="warning">未认证</van-tag>
                                    <van-tag round plain v-else-if="item.cardtype!=1 && item.cert_status==2"  >无需认证</van-tag>  &nbsp;
                                     {{item.num}}
                                </div>
                            </div>
                        </div>
                    </div>
                    </van-list>
            </van-pull-refresh>
            <van-action-sheet v-model="actionShow" :actions="actions" @select="onActionSelect" />
            <van-button
                        color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                        style="
                bottom: 80px;
                right: 10px;
                position: fixed;"
                        size="normal" round
                        @click="onTongbu"
                        >同步CCA官网
                    </van-button>
            <div class="savebtn">
                <van-button
                        color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                        style="width: 3rem"
                        size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中..." @click="addShow=true">新增</van-button>
            </div>


            <van-popup
                    position="bottom"
                    :style="{ height: '60%' }"
                    v-model="addShow"
                    @click-overlay="addShow=false"
            >
                <div style="margin-top: 0.2rem ; margin-bottom: 1.5rem">
                    <van-form
                            @submit="onSubmit"
                            @failed="onFailed"
                    >
                    <van-divider>新增裁判员</van-divider>
                    <van-cell-group>
                        <van-field
                                v-model="formData.name"
                                label="姓名"
                                :rules="[{ required: true, message: '姓名不能为空' }]"
                                error-message-align="right"
                                input-align="right"
                                clearable
                                placeholder="请输入姓名"
                        />
                        <van-field
                                readonly
                                clickable
                                right-icon="arrow"
                                input-align="right"
                                @click="showNumTypePicker=true"
                                label="证件类型"
                                v-model="formData.numTypeName"
                        />
                        <van-popup v-model="showNumTypePicker" position="bottom">
                            <van-picker :columns="numTypeColumns"
                                        show-toolbar
                                        :default-index="formData.cardtype-1"
                                        @cancel="showNumTypePicker = false"
                                        @confirm="onNumTypeConfirm"
                            />
                        </van-popup>



                        <van-field
                                v-if="formData.cardtype==1"
                                v-model="formData.num"
                                :rules="[{ validator: validator.idCard,message:'请输入正确的身份证号'}]"
                                error-message-align="right"
                                label="身份证号"
                                input-align="right"
                                clearable
                                placeholder="请输入身份证号"
                        />

                        <van-field
                                v-model="formData.huzhao"
                                v-if="formData.cardtype!=1"
                                label="证件号码"
                                :rules="[{ required: true, message: '证件号码不能为空' }]"
                                error-message-align="right"
                                input-align="right"
                                clearable
                                placeholder="请输入证件号码"
                        />


                        <van-field
                                v-model="formData.phone"
                                label="手机"
                                :rules="[{ validator: validator.phone,message:'请输入正确的手机号'}]"
                                error-message-align="right"
                                input-align="right"
                                clearable
                                placeholder="请输入手机号"
                        /> 

                        <van-field
                                v-model="formData.phonecode"
                                label="验证码"
                                :rules="[{ required: true,message:'请输入验证码'}]"
                                error-message-align="right"
                                input-align="right"
                                clearable
                                placeholder="请输入验证码"
                        >
                        <template #button>
                        <van-button @click="getCode" native-type="button" size="small" type="primary" :disabled="clockSecond>0">{{clockSecond>0?
                    '('+clockSecond+'s)':'获取验证码'}}</van-button>
                        </template>
                        </van-field>

                        <van-field
                                v-model="formData.email"
                                :rules="[{ validator: validator.email,message:'请输入正确的邮箱'} ]"
                                error-message-align="right"
                                label="邮箱"
                                input-align="right"
                                clearable
                                placeholder="请输入邮箱"
                        />

                        <van-field
                                v-model="formData.qq"
                                label="QQ"
                                error-message-align="right"
                                input-align="right"
                                clearable
                                placeholder="请输入QQ"
                        />

                        <van-field
                                v-model="formData.weixin"
                                label="微信"
                                error-message-align="right"
                                input-align="right"
                                clearable
                                placeholder="请输入微信"
                        />

                    </van-cell-group>

                        <IdCardPicker style="margin: 0 auto; margin-top: 20px; width: 4rem; text-align: center; border-radius: 1rem; border: 1px solid #eee ;  line-height: 0.6rem" @success="onIdSuccess" />

                    <div class="savebtn">
                        <van-button
                                color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                                style="width: 3rem"
                                size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中..." native-type="submit" >保存</van-button>
                    </div>
                    </van-form>
                </div>
            </van-popup>


        </div>



    </div>
</template>
<style scoped>

    .savebtn {
        position: fixed;
        bottom: 0;
        padding-bottom: 0.2rem;
        width: 100%;
        z-index: 10;
        display: flex;
        flex: 1;
        flex-direction: row;
        justify-content: space-around;
        background: linear-gradient(180deg,hsla(0,0%,100%,0),#fff);
    }
    .box {
        /*margin-bottom: 50px;*/
        background: rgba(248,248,248,1);
        min-height: 90vh;
    }
    .kaojicenter-list-box {
        padding-top: 0.2rem;
        /*background: rgba(248,248,248,1);*/
    }

    .goods-line {
        height: 55px;
    }

    .goods-bottom-line {
        width: 100%;
        position: fixed;
        height: 60px;
        bottom: 0;
        background: linear-gradient(180deg, hsla(255, 0%, 100%, 0), #fff);
    }

    .goods-create-btn {
        position: fixed;
        bottom: 10px;
        width: 100%;
        height: 44px;
        font-size: 16px;
        text-align: center;
    }

    .goods-create-btn button {
        width: 3.2rem;
    }

    .goods-create-btn img {
        width: 60px;
        height: 60px;
    }

    .goods-header {
        display: flex;
        justify-content: space-between;
        position: fixed;
        top: 0;
        z-index: 99;
        width: 100%;
        margin-bottom: 0.01rem;
        background: #fff;
    }
    .screen-btn {
        line-height: 44px;
        height: 44px;
    }

    .screen-btn img {
        width: 45%;
        padding-left: 15px;
        vertical-align: middle;
        border-left: 1px solid #D5D5D5;
    }

    .sidebar {
        padding-top: 15px;
    }

    .search-box img {
        width: 60px;
        height: 60px;
    }


    .select-btn {
        position: fixed;
        bottom: 0;
        width: 90%;
        margin: 0 auto;
        padding: 0px 15px 30px;
    }

    .btn-reset {
        padding-bottom: 10px;
    }

    .btn-reset >>> .van-button {
        background: #ddd;
    }

    .selected {
        color: #444;
    }


    .kaojicenter-lists {
        padding: 0.2rem;
        border-radius:10px;
        background: #fff;
        margin: 0 0.2rem 0.2rem;
    }

    .kaojicenter-lefts {
        position: relative;
    }


    .kaojicenter-lefts .img {
        border-radius: 10px;
        width: 1rem;
        height: 1rem;
    }

    .kaojicenter-rights {
        width:calc(100% - 1.2rem);
        position: relative;
        height: 1rem;
    }

    .kaojicenter-rights .title{
        font-size: 15px;
        font-weight: bold;
    }
    .kaojicenter-rights .desc{
        font-size: 12px;
        padding-top: 10px;
        color: #999;
    }



</style>

<script>
    import Vue from 'vue';
    import validator from "../../../utils/validator";

    import {Cell, CellGroup, Toast, Dialog, Icon, PullRefresh, List, Tag, Button,DropdownMenu, DropdownItem,DatetimePicker} from 'vant';

    import IdCardPicker from "../../../components/picker/IdCardPicker.vue";
    Vue.use(Cell).use(CellGroup).use(Toast).use(Dialog).use(Icon).use(Tag).use(Button).use(DropdownMenu).use(DropdownItem).use(DatetimePicker);
    export default {
        name: 'CaipanList',
        components: {
            [PullRefresh.name]: PullRefresh,
            [List.name]: List,
            IdCardPicker
        },
        data: function () {
            return {
                validator,
                id: 0,
                clockSecond: 0,
              active: 0,
                showDate: false,
                actionShow: false,
                addShow:false,
                list: [],
                minDate: new Date(1900, 0, 1),
                maxDate: new Date(),
                currentDate: new Date(2015, 0, 1),
                showNumTypePicker:false,
                numTypeColumns: ['身份证', '护照','其他身份证明'],
                actions:[
                    { name: '隐藏' },
                    { name: '认证' },
                ],
                params: {
                    pageNo: 1,
                    pageSize: 10,
                    keywords: '',
                    cate_id: 0,
                    status: 1,
                  is_show: 1,
                },
                formData:{
                    name:'',
                    num:'',
                    huzhao:'',
                    cardtype:1,
                    numTypeName:'身份证',
                    phone:'',
                    email:'',
                    qq:'',
                    weixin:'',
                },
                saveLoading:false,
                isLoading: false,
                loading: false,
                finished: false,

            }
        },
        mounted() {
            document.title = "裁判员管理"
            this.getList();
        },
        computed:{
            showBirthday(){
                return this.formData.cardtype !=1 ;
            },
            showSex(){
                return this.formData.cardtype !=1 ;
            },
        },
        filters:{
            cert(value){
                switch (value){
                    case 1 :
                        return '#ff0000'
                        break;
                    case 2 :
                        return '#FF9966'
                        break;
                    case 3 :
                        return '#FFFF33'
                        break;

                }
            }
        },
        destroyed() {
        },
        methods: {
            getList() {
                let that = this;
                that.$api.get('/api/caipan/caipanList', that.params, (res) => {
                    that.loading = false;

                    if (res.data.currentpage == 1) {
                        that.isLoading = false;
                        that.list = res.data.list
                    } else {
                        let list = that.list.concat(res.data.list);

                        that.list = list;
                    }

                    if (res.data.list.length == 0) {
                        that.finished = true;
                    }
                    that.params.pageNo += 1;
                })
            },


            // 上拉加载
            // （页面显示没有更多了的原因 ）数据加载过慢 导致第一页数据未获取到时，已经请求第二页数据了
            // 可以延迟异步的时间
            onLoad() {
                // console.log(1)
                // 异步更新数据
                console.log('this.params.pageNo')

                if (this.params.pageNo > 1) {
                    setTimeout(() => {
                        this.getList()
                    }, 500);
                }

            },

            action(item,index){

                this.actionShow = true;
                this.params.id = item.id;
                this.params.name = item.name;
              this.actions = [];
              if (item.is_show == 1) {
                this.actions.push({name: '隐藏'});
              } else {
                this.actions.push({name: '显示'});
              }
              if (item.cert_status == 2) {
                this.actions.push({name: '认证'});
              } else {
              }

            },
            onActionSelect(action,index){
                let that = this;
                switch (index){
                  case 0 :
                    if (action.name == '隐藏') {
                      Dialog.confirm({
                        title: '确认',
                        message: '是否隐藏该裁判员?',
                      })
                          .then(() => {
                            // on confirm
                            that.$api.post('/api/caipan/hide', {
                              id: that.params.id
                            }, (res) => {
                              that.onRefresh();
                            }, (res) => {
                              Toast.fail(res.msg);
                            })

                          })
                          .catch(() => {
                            // on cancel
                          });
                    } else {
                      that.$api.post('/api/caipan/show', {
                        id: that.params.id
                      }, (res) => {
                        that.onRefresh();
                      }, (res) => {
                        Toast.fail(res.msg);
                      })
                    }

                    this.actionShow = false;
                    break;

                  case 1 :
                    that.$api.post('/api/caipan/cert', {
                      id:that.params.id
                    }, (res) => {
                      that.onRefresh();
                    }, (res) => {
                      Toast.fail(res.msg);
                    })
                        break;

                    case 2 :


                        break;

                }
                this.actionShow = false;
            },

            onRefresh() {
                let that = this;
                that.params.pageNo = 1;
                that.getList();
            },
            onTongbu(){
                let that = this;
                that.$api.post('/api/caipan/tongbuCca', {}, (res) => {
                    Toast(res.msg);
                    that.onRefresh();
                }, (res) => {
                    Toast.fail(res.msg);
                    that.saveLoading = false;
                })
            },
            onDateConfirm(date){
                console.log('onDateConfirm',date);
                this.showDate = false;
                this.formData.birthday =  `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
            },
            submit(){

            },
            onIdSuccess(data){
                console.log('onIdSuccess',data);
                this.formData.name = data.name;
                this.formData.num = data.cardNum;
            },
            onNumTypeConfirm(value, index){
                this.formData.numTypeName = value;
                this.formData.cardtype = index+1;
                this.showNumTypePicker = false;
            },
            onFailed(errorInfo){
                console.log('failed', errorInfo);
            },
            onSubmit(values){
                console.log('onSubmit-values',values);
                console.log('submitType',this.submitType);

                let that = this;
                console.log(that.formData)
                that.formValidate = true;
                for (let field in that.formData) {

                }
                that.saveLoading = true;
                that.$api.post('/api/caipan/add', that.formData, (res) => {
                    that.saveLoading = false;
                    that.addShow = false;
                    that.onRefresh();
                    that.formData = {
                        name:'',
                        num:'',
                        huzhao:'',
                        cardtype:1,
                        numTypeName:'身份证',
                        phone:'',
                        email:'',
                        qq:'',
                        weixin:'',
                    };
                }, (res) => {
                    Toast.fail(res.msg);
                    that.saveLoading = false;
                })
            },
          // 更改状态
          onStatusChange(index) {

            let that = this;
            that.params.is_show = index + 1;
            that.params.pageNo = 1;

            // 激活下拉
            that.finished = false;
            that.loading = true;
            that.list = [];

            this.$route.query.is_show = 0;
            that.getList()
          },


            getCode() {
                let that = this;
                if (that.clockSecond > 0) {
                    return;
                }
                if (!that.formData.phone) {
                    Toast('请输入手机号')
                    return;
                }
                /*if (!that.formData.code) {
                    Toast('请输入验证码')
                    return;
                }*/
                that.$api.get('/api/index/phonecode', {phone: that.formData.phone}, (res) => {
                    Toast(res.msg);
                })

                that.clockSecond = 60;

                var t = setInterval(function () {
                    if (that.clockSecond > 0) {
                        that.clockSecond = that.clockSecond - 1;
                    } else {
                        clearInterval(t);
                    }
                }, 1000)
            }

        }
    }
</script>



// WEBPACK FOOTER //
// CaipanList.vue?3aa531d4